import { render } from "./InputHorizontal.vue?vue&type=template&id=0803aa64"
import script from "./InputHorizontal.vue?vue&type=script&lang=js"
export * from "./InputHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__